import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
// import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatCurrency,
  formatDate,
  replaceNulls,
  sizePerPageList,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

export const SettingJourneyTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  // const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      const newItem = replaceNulls(item);
      return {
        ...newItem,
        no: index + 1 + pageBefore,
      };
    });

    console.log(initData);
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="settingJourneys-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              history.push(
                `/master/journey-setting/edit/${row.journey_setting_id}`
              );
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "sales code",
      dataField: "company_sales_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(`/master/journey-setting/edit/${row.user_id}`);
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: "sales name",
      dataField: "company_sales_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Senin",
      dataField: "Senin",

      style: { minWidth: "60px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(
                `/master/journey-setting/route/${row.user_id},Senin`
              );
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: "Selasa",
      dataField: "Selasa",

      style: { minWidth: "60px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(
                `/master/journey-setting/route/${row.user_id},Selasa`
              );
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: "Rabu",
      dataField: "Rabu",

      style: { minWidth: "60px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(`/master/journey-setting/route/${row.user_id},Rabu`);
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: "Kamis",
      dataField: "Kamis",

      style: { minWidth: "60px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(
                `/master/journey-setting/route/${row.user_id},Kamis`
              );
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: "Jumat",
      dataField: "Jumat",

      style: { minWidth: "60px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(
                `/master/journey-setting/route/${row.user_id},Jumat`
              );
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: "Sabtu",
      dataField: "Sabtu",

      style: { minWidth: "60px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(
                `/master/journey-setting/route/${row.user_id},Sabtu`
              );
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: "Minggu",
      dataField: "Minggu",

      style: { minWidth: "60px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              history.push(
                `/master/journey-setting/route/${row.user_id},Minggu`
              );
            }}
          >
            {cell}
          </span>
        );
      },
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };
  return (
    <>
      <BootstrapTable
        remote
        striped
        noDataIndication="Data Not Found"
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={true}
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
